




















































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { ShipnityEditorForm } from "../forms/ShipnityEdtiorForms";
import { Shop } from "../../shop/models/Shop";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => ShipnityEditorForm
    },
    shops: {
      type: Array as () => Shop[]
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel(
      "shop",
      "shopName",
      "email",
      "token",
      "mcApiKey",
      "mcSecretkey",
      "stockIdValue"
    ),
    isUpdateState() {
      return (this as any).state === "UPDATE";
    },
    shopError() {
      return (this as any).validations.shop.$error
        ? "shop is required or invalid"
        : "";
    },
    shopNameError() {
      return (this as any).validations.shopName.$error
        ? "shopName is required or invalid"
        : "";
    },
    emailError() {
      return (this as any).validations.email.$error
        ? "email is required or invalid"
        : "";
    },
    tokenError() {
      return (this as any).validations.token.$error
        ? "token is required or invalid"
        : "";
    },
    mcApiKeyError() {
      return (this as any).validations.mcApiKey.$error
        ? "MC API Key is required or invalid"
        : "";
    },
    mcSecretkeyError() {
      return (this as any).validations.mcSecretkey.$error
        ? "MC Secret Key is required or invalid"
        : "";
    },
    stockIdValueError() {
      return (this as any).validations.stockIdValue.$error
        ? "Stock Id invalid"
        : "";
    }
  }
});
